<!-- ======= Whu Us Section ======= -->
<section id="why-us" class="why-us">
  <div class="container">

    <div class="section-title">
      <!--<h2>{{titleSectores}}</h2>-->
      <!--<h2>Why choose <span>Our Restaurant</span></h2>-->
      <p>Ut possimus qui ut temporibus culpa velit eveniet modi omnis est adipisci expedita at voluptas atque vitae
        autem.</p>
    </div>

    <div class="row">

      <!--<div class="col-lg-4">
          <div class="box">
            <span>01</span>
            <h4>Lorem Ipsum</h4>
            <p>Ulamco laboris nisi ut aliquip ex ea commodo consequat. Et consectetur ducimus vero placeat</p>
          </div>
        </div>-->

      <div *ngFor="let sector of sectores" class="col-lg-4 mt-4 mt-lg-0">
        <!--<div class="box" style="background: url(assets/img/barrios/{{sector.imageUrl}});">-->
        <div class="box" >
          <span>{{sector.barrio}}</span>
          <h4>{{sector.codigo}}</h4>
          <img src="assets/img/barrios/{{sector.imageUrl}}" alt="" srcset="" class="img-fluid">
          <p [innerHTML]="sector.descripcion">descrpion</p>
          <a href="#" class="btn btn-primary">Ver más</a>
        </div>
      </div>



    </div>

  </div>
</section>